import { EmbeddedRecordsMixin } from '@warp-drive/legacy/serializer/rest';
import PostsSerializer from './base';

export default class Page extends PostsSerializer.extend(EmbeddedRecordsMixin) {
  attrs = {
    pageSetIds: { serialize: 'ids' },
  };
}
